import React, { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import {
  FiHome,
  FiCreditCard,
  FiShoppingCart,
  FiPlusCircle,
  FiBell,
  FiUsers,
  FiHeadphones,
  FiPhone,
  FiHeart,
  FiUser,
  FiLogOut,
} from "react-icons/fi";
import { setLogout } from "../redux/slices/authSlice";
import { useTranslation } from "../i18n";

function SideMenu({ onNavigate }) {
  const user = useSelector((state) => state.auth.user);
  const settings = useSelector((state) => state.catalog.setting);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const levelImage = user?.level_image || null;
  const levelFrameColor = user?.level_frame_color || "#9ca3af";

  const logout = () => {
    dispatch(setLogout());
    navigate("/login");
  };

  const item = (to, Icon, label, extra) => (
    <NavLink
      onClick={onNavigate}
      className={({ isActive }) => (isActive ? "nav__item is-active" : "nav__item")}
      to={to}
      end={to === "/" || to === "/wallet"}
    >
      <span className="ico" aria-hidden="true">
        <Icon size={20} />
      </span>
      <span>{label}</span>
      {extra}
    </NavLink>
  );

  return (
    <aside className="sidebar">
      <div className="brand">
        <div className="brand__logo">
          <img src="/images/logo.png" alt="Logo" />
        </div>
        <div>
          <div className="brand__name">
            T<b>STORE</b>
          </div>
          <div className="brand__sub">{t("nav.brandSub")}</div>
        </div>
      </div>

      <nav className="nav">
        <div className="nav__label">{t("nav.menu")}</div>
        {item("/", FiHome, t("nav.home"))}
        {item("/wallet", FiCreditCard, t("nav.wallet"), <span className="badge">$</span>)}
        {item("/orders", FiShoppingCart, t("nav.orders"))}
        {item("/deposit", FiPlusCircle, t("nav.deposit"))}

        <div className="nav__label">{t("nav.services")}</div>
        {item("/virtual-numbers", FiPhone, t("nav.virtualNumbers"))}
        {item("/agent", FiUsers, t("nav.agents"))}
        {item("/tickets", FiHeadphones, t("nav.support"))}
        {item("/noty", FiBell, t("nav.notifications"))}
        {item("/favorite", FiHeart, t("nav.favorite"))}
        {item("/Profile", FiUser, t("nav.profile"))}
      </nav>

      <div className="side-user">
        <div
          style={{
            position: "relative",
            width: 56,
            height: 56,
            borderRadius: "50%",
            padding: 3,
            background: levelImage
              ? `url(${levelImage}) center/cover no-repeat`
              : levelFrameColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <img
            className="side-user__avatar"
            src={user?.avatar ? `${process.env.REACT_APP_UPLOADS_URL || "http://localhost:8089"}/uploads/users/` + user.avatar : "https://i.pravatar.cc/80?img=12"}
            alt="avatar"
            style={{ width: 50, height: 50, borderRadius: "50%", objectFit: "cover" }}
          />
        </div>
        <div className="side-user__meta">
          <div className="side-user__name">{user?.name}</div>
          <div className="side-user__mail">{user?.email}</div>
        </div>
        <button className="side-user__logout" title={t("nav.logout")} aria-label={t("nav.logout")} onClick={logout}>
          <FiLogOut size={18} />
        </button>
      </div>
    </aside>
  );
}

export default memo(SideMenu);
